import { ApiClient } from './api-client';
import config from '../../../config';

function apiSingleton({ apiPrefix } = {}) {
    if (!apiPrefix) {
        throw new Error('[apiPrefix] required');
    }

    return new ApiClient({ prefix: apiPrefix });
}

const apiClient = apiSingleton({ apiPrefix: config.apiPrefix });

export {
    apiClient
};
